module.exports = __webpack_public_path__ + "img/40_69_000_140.cd9beb91.jpg";